export default __webpack_public_path__ + "static/media/cloud-1.59fe3bd0.webp";